import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CalculationTemplatesViewPage } from '@/areas/calculations/Calculation/Templates/TemplatesView/CalculationTemplatesViewPage';
import { canViewCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/calculation/')({
    staticData: { access: { permissions: canViewCalculationTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CalculationTemplatesViewPage />;
}
